import { render, staticRenderFns } from "./ReceptionPage.vue?vue&type=template&id=66f164c1&scoped=true"
import script from "./ReceptionPage.vue?vue&type=script&lang=js"
export * from "./ReceptionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f164c1",
  null
  
)

export default component.exports